import React from "react";

/**
 * Display product variants / attributes as readable chips.
 *
 * For MVP we show non-editable info chips — visual hint that the product
 * has a specific color/size/material. When admin adds real variant products,
 * this component will switch to selectable swatches.
 */
const VARIANT_KEYS = [
  "Variation Attributes: Color",
  "Variation Attributes: Size",
  "Color",
  "Size",
  "Material",
  "Style",
];

const DISPLAY_LABEL = {
  "Variation Attributes: Color": "Color",
  "Variation Attributes: Size": "Size",
};

export default function ProductVariants({ attributes = {} }) {
  const items = VARIANT_KEYS
    .map((k) => ({ key: k, label: DISPLAY_LABEL[k] || k, value: attributes[k] }))
    .filter((x) => x.value && String(x.value).trim());

  if (items.length === 0) return null;

  return (
    <div className="mt-6 space-y-4" data-testid="product-variants">
      {items.map(({ key, label, value }) => (
        <div key={key}>
          <div className="mb-2 text-xs uppercase tracking-[0.2em] text-[#2D2823]">
            {label}
          </div>
          <div className="flex flex-wrap gap-2">
            <span className="inline-flex min-w-[64px] items-center justify-center rounded-full border border-[#1A1A1A] bg-white px-4 py-1.5 text-sm text-[#1A1A1A]">
              {value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
